// extracted by mini-css-extract-plugin
module.exports = {"UsageScenariosD":"UsageScenariosD_UsageScenariosD__2xoAT"};